// extracted by mini-css-extract-plugin
module.exports =  {"root":"u0nfU9oQXTlqw5QzvvmN","left":"TvlLj0vWPFG3UdpJWUnC","right":"Af3WFeB2X8RsZsp476e4"};